{
  "activityFeed": {
    "events": {
      "added": "Added | Added {count} new products:",
      "restocked": "Restocked new product | Restocked {count} new products:"
    },
    "empty": "No activities available.",
    "heading": "Activity Feed",
    "more": "+ {count} more",
    "subHeading": "View updates from brands in your market.",
    "viewMore": "View More"
  },
  "addAnotherLocation": "Add another location",
  "addAllToCart": "Add all to cart",
  "addAllToCartFormErrors": "Cannot add to cart.\nPlease review items for errors.",
  "addAllToCartEmptyQuantitiesError": "Please provide a quantity for one or more items and try again.",
  "addLicenseError": "Please update the license on your account to be able to shop for products.",
  "addToCart": "Add to Cart",
  "addToCartSuccess": "Added to Cart",
  "addToStoreFavorites": "Add to Store Favorites",
  "removeFromStoreFavorites": "Remove from Store Favorites",
  "allBrands": "All Brands",
  "brands": {
    "badges": {
      "compliant": "Compliant",
      "compliantTooltip": "This seller uses LeafLink's compliance workflows, which can save you time on inventory intake.",
      "eliteSeller": "Sold by a LeafLink Certified Elite Seller",
      "list_winner": "LeafLink List Winner",
      "listWinner": "LeafLink List {year} winner",
      "llFinancial": "LeafLink Financial Net terms are offered by this seller",
      "llLogistics": "Fulfills orders with LeafLink Logistics",
      "new": "New",
      "powerSeller": "Sold by a LeafLink Certified Power Seller",
      "socialEquityVerified": "This company is part of the following Social Equity Programs: {programs}",
      "trusted_seller": "Trusted Seller",
      "verified": "Verified",
      "verifiedTooltip": "This seller has a verified license."
    },
    "filters": {
      "badges": {
        "arabMiddleEasternOwned": "Arab/Middle Eastern Owned",
        "asianOwned": "Asian Owned",
        "blackOwned": "Black Owned",
        "disabilityOwned": "Disability Owned",
        "eliteSeller": "Elite Sellers",
        "indigenousOwned": "Indigenous Owned",
        "label": "Seller Badges",
        "latinxOwned": "Latinx Owned",
        "leaflinkListWinner": "LeafLink List Winner",
        "lgbtqiaOwned": "LGBTQIA Owned",
        "listWinners": "LeafLink List Winners",
        "llLogistics": "Ship with LeafLink",
        "new": "New to LeafLink",
        "pacificIslanderOwned": "Pacific Islander Owned",
        "powerSeller": "Power Sellers",
        "sellerOnPayments": "Pay with LeafLink",
        "socialEquityVerified": "Social Equity Verified",
        "veteranOwned": "Veteran Owned",
        "womenOwned": "Women Owned"
      },
      "ancillary": {
        "label": "Ancillary Brands",
        "allBrands": "All Brands"
      },
      "categories": {
        "accessories": "Accessories",
        "cartridges": "Cartridges",
        "concentrates": "Concentrates",
        "edibles": "Edibles & Ingestibles",
        "flower": "Flower",
        "label": "Category",
        "preRolls": "Pre-Rolls",
        "topicals": "Topicals"
      },
      "category": "Category",
      "categoryPlaceholder": "All Categories",
      "doesNotHaveProposedQuantity": "Does Not Have Proposed Quantity",
      "flowerPackageSizeLabel": "Flower Package Size",
      "flowerPackageSizePlaceholder": "Select Package Size",
      "hasProposedQuantity": "Has Proposed Quantity",
      "hideAncillaryLabel": "Hide Ancillary Products",
      "priceRangeLabel": "Price Range",
      "productStatusLabel": "Product Status",
      "productStatusPlaceholder": "Select Product Status",
      "proposedQuantity": "Proposed Quantity",
      "purchase_history": {
        "label": "Purchase History",
        "previously_ordered": "Previously Ordered",
        "yet_to_order": "Yet To Order"
      },
      "sellersPaymentMethod": {
        "label": "Seller's Payment Method",
        "paymentOnSellThrough": "Payment on Sell Through",
        "directPay": "Direct Pay",
        "flexPay": "Flex Pay"
      },
      "purchaseHistoryPlaceholder": "Select Purchase History",
      "salePriceLabel": "Has Sale Price",
      "socialIdentity": {
        "label": "Social Identity Tags"
      },
      "soldInBulkLabel": "Sold in Bulk",
      "strainClassificationPlaceholder": "Select Classification",
      "unitOfMeasurePlaceholder": "Select Size or Weight",
      "volumeDiscountLabel": "Has Volume Discount"
    },
    "brandLogo": "Brand logo",
    "heading": "Shop Brands",
    "liveInventoryUpdates": "Live Inventory Updates",
    "liveInventoryUpdatesTooltip": "This customer has updated their inventory counts from Metrc this week",
    "no_brands_available": "No Brands Available",
    "no_brands_error": "Error Loading Brands",
    "paymentsCta": {
      "title": "Let LeafLink power your digital payments",
      "description": "LeafLink empowers retailers to initiate digital payments, and easily reconcile them with your invoices.  Simplify your accounts payable and remove the costs associated with processing cash and checks."
    },
    "searchPlaceholder": "Search by Brand Name",
    "sub_heading": "Search through our growing network of brands."
  },
  "buyItAgain": {
    "description": "Easily access and purchase your recently ordered products.",
    "title": "Buy It Again"
  },
  "cartQty": "Cart Qty",
  "categoryManagement": {
    "parInsight": {
      "insight": "You have {daysInInventory} days on hand left",
      "remaining": "({quantityInStock} quantity in stock)"
    }
  },
  "clickHereToManageLicenses": "Click here to manage licenses",
  "currentlyInCart": "Currently in Cart",
  "deals": {
    "featuredOnDeals": "The product is featured on {campaignLabel}",
    "heading": "Shop Deals"
  },
  "discover": {
    "description": "Explore the latest products and offers from top brands.",
    "neverTried": "Never Tried",
    "newProducts": "New to LeafLink",
    "recommended": "Recommended",
    "rediscover": "Rediscover",
    "title": "Discover"
  },
  "editLocations": "Edit Locations",
  "exportMenu": "Export Menu",
  "exportShowImages": "Show images",
  "exportShowQuantities": "Show available product quantities",
  "exportIncludeInternalProducts": "Include products marked as Internal",
  "expressMenu": {
    "gateModal": {
      "title": "Verify Your Details",
      "brandHeading": "Quickly browse and shop products from {brandName}.",
      "subtitle": "Please verify your details below to ensure compliance with licensing regulations and view available products based on your license type.",
      "form": {
        "email": "LeafLink Email Address",
        "company": "Company",
        "companyPlaceholder": "Select Company Name",
        "emailError": "No matching email found"
      },
      "termsAndConditions": "By entering this site you agree to our {termOfService} and {privacyPolicy}.",
      "continue": "@:common.continue"
    },
    "orderConfirmationModal": {
      "deliveringTo": "Delivering to",
      "title": "Confirm Order Details",
      "termsAndConditions": "By submitting this order you agree to our {termOfService} and {privacyPolicy}.",
      "orderNotes": "Order Notes / Delivery Preferences",
      "paymentOption": "Payment Option",
      "offPlatformPaymentDefault": "@:cart.payments.nonLLPayment (@:common.default)",
      "offPlatformPaymentHintText": "@:cart.payments.noOffPlatformOptionsAvailable"
    },
    "orderSuccess": {
      "title": "Order Sent Successfully",
      "description": "Your order has been successfully submitted. You'll receive an email once it's been accepted.",
      "startNewOrder": "Start New Order",
      "viewOrder": "View Order"
    },
    "previewModeTooltip": "Preview Mode: Buyers will have ordering access once sent the menu",
    "topNav": {
      "scheduleADemo": "Schedule a demo",
      "signupAsARetailer": "Sign up as a retailer"
    },
    "footer": {
      "clearOrder": "Clear Order",
      "orderTotal": "Order Total:",
      "productsValidationErrorCount": "@:brand_menu.addToCartErrorCount",
      "submitOrder": "Submit Order"
    }
  },
  "featured_image": "Featured Image",
  "featuredProduct": "Featured Product",
  "leafLinkOnInstagram": "Follow LeafLink on Instagram {'@'}LeafLink_",
  "learnMoreRequestSuccess": "Learn more request sent",
  "loading_deals": "Loading Deals",
  "no_products": "No Products",
  "notifyWhenAvailable": "Notify me when available",
  "notifyWhenAvailableSuccess": "Your notify me request has been sent to the seller",
  "notOnPurchaseList": "Not on purchase list",
  "onPurchaseList": "Currently on purchase list",
  "otherProducts": "Other Products",
  "paymentsBadge": {
    "modal": {
      "description": "@:cart.payments.sellerOnPaymentsDescription",
      "descriptionInterested": "Our team is evaluating your submission to see if your business is qualified for our current offering. We will reach out to you with next steps shortly.",
      "joinToday": "Join today",
      "submitText": "@:cart.payments.signMeUp",
      "title": "@:cart.payments.sellerOnPaymentsTitle",
      "titleInterested": "Thanks for your interest in Payments!"
    },
    "tooltip": "This seller is on Payments"
  },
  "productLineMoved": "Product line moved",
  "productMoved": "Product moved",
  "products": {
    "description": "Search our vast selection of products by category, brand, and more.",
    "filters": {
      "categoryPlaceholder": "All Categories",
      "doesNotHaveProposedQuantity": "Does Not Have Proposed Quantity",
      "flowerPackageSizeLabel": "Flower Package Size",
      "flowerPackageSizePlaceholder": "Select Package Size",
      "hasProposedQuantity": "Has Proposed Quantity",
      "hideAncillaryLabel": "Hide Ancillary Products",
      "priceRangeLabel": "Price Range",
      "productStatusLabel": "Product Status",
      "productStatusPlaceholder": "Select Product Status",
      "proposedQuantity": "Proposed Quantity",
      "purchaseHistoryLabel": "Purchase History",
      "purchaseHistoryPlaceholder": "Select Purchase History",
      "salePriceLabel": "Has Sale Price",
      "soldInBulkLabel": "Sold in Bulk",
      "strainClassificationPlaceholder": "Select Classification",
      "unitOfMeasurePlaceholder": "Select Size or Weight",
      "volumeDiscountLabel": "Has Volume Discount"
    },
    "heading": "Shop Products",
    "searchPlaceholder": "Search Products by Name",
    "sort": {
      "brand_name_asc": "Brand Name (A-Z)",
      "brand_name_desc": "Brand Name (Z-A)",
      "cartQtyAsc": "Cart Quantity (Low to High)",
      "cartQtyDesc": "Cart Quantity (High to Low)",
      "date_asc": "Date (Low to High)",
      "date_desc": "Date (High to Low)",
      "price_asc": "Price (Low to High)",
      "price_desc": "Price (High to Low)",
      "product_name_asc": "Product Name (A-Z)",
      "product_name_desc": "Product Name (Z-A)"
    },
    "validation": {
      "greaterThanOrEqualToMinPriceRange": "Must be greater than or equal to the minimum Price Range",
      "greaterThanOrEqualToMinTHCRange": "Must be greater than or equal to the minimum THC Range",
      "lessThanOrEqualToMaxPriceRange": "Must be less than or equal to the maximum Price Range",
      "lessThanOrEqualToMaxTHCRange": "Must be less than or equal to the maximum THC Range",
      "quantityMaximum": "Quantity must be less than the maximum order",
      "quantityMinimum": "Quantity must be greater than the minimum order"
    }
  },
  "promos": {
    "copied": "Copied!",
    "copyCode": "Copy code",
    "ends": "Ends {date}.",
    "minimum": "Minimum {minimum}. ",
    "promo": "PROMO",
    "promoMessage": "<strong class=\"color-ice-900 font-weight-bold\">{code}</strong> use code at checkout for {discount} off. ",
    "promoMessageAutomatic": "<strong class=\"color-ice-900 font-weight-bold\">{discount} off all orders</strong> auto-applied at checkout. "
  },
  "publicMenu": {
    "accessDeniedDescription": "You are not allowed to purchase from {brandName}.",
    "footer": {
      "disclaimer": "Disclaimer",
      "privacy": "Privacy",
      "registeredTrademark": "LEAFLINK® is a registered trademark of LeafLink, Inc",
      "terms": "Terms & Conditions"
    },
    "sidebarContent": "Purchasing managers from thousands of dispensaries save up to 8 hours per week by centralizing their orders and vendor communication through LeafLink, the unified B2B cannabis platform. Sign up for a free account in minutes and start shopping from leading cannabis brands including {brand} today!",
    "sidebarHeader": "Order {brand} wholesale on LeafLink",
    "signUp": "Sign Up to Shop",
    "title": "{brand} Menu",
    "topNav": {
      "brandDemo": "Brand Demo",
      "retailerAccount": "Retailer Account"
    }
  },
  "purchaseHistory": "Purchase history",
  "purchaseHistoryDescription": "Purchase history for your stores",
  "purchaseHistoryEmptyText": "Your purchase history will appear here once you start placing orders!",
  "purchaseList": {
    "readyForReview": "Ready for review",
    "readyForReviewConfirmation": "The {buyerName} Purchase List has been sent to {reviewerNames} for review",
    "readyForReviewModal": {
      "description": "Notify reviewers that this list is ready for review.",
      "title": "Ready for Review"
    },
    "reviewer": "Reviewer",
    "selectReviewerPlaceholder": "Select a reviewer",
    "title": "Purchase List",
    "updateNoteConfirmation": "Notes for the {buyerName} Purchase List have been updated"
  },
  "purchaseListItemUpdated": "Item updated successfully.",
  "purchasing": "Purchasing",
  "recommended": "Recommended for you",
  "removeFromPurchaseListSuccessMessage": "Product was successfully removed from Purchase Lists",
  "requestSample": "Request Sample",
  "saleDiscountTooltip": "This item is on sale.",
  "sampleRequestSuccess": "Sample request sent",
  "shop": {
    "heading": "Shop",
    "subHeading": "Search through our growing network of brands and products"
  },
  "shop_all_deals": "Shop all deals from this seller",
  "shop_december_deals": "Shop December Deals",
  "sponsored": "Sponsored",
  "sponsoredImage": "Sponsorship for {name}",
  "storeFavorites": {
    "title": "Store favorites",
    "addProductDropdownLabel": "Search for a Brand or Product"
  },
  "storeFavoritesEmptySubtext": "Use the add products option above to create a custom list.",
  "storeFavoritesEmptyText": "You haven't created a custom list for this license yet",
  "tabs": {
    "brands": "Shop Brands",
    "discover": "Discover Products",
    "products": "Shop Products"
  },
  "vendorDetails": {
    "brandsBy": "Brands by {name}",
    "noBrands": "This company does not have any brands",
    "noRecentOrders": "You do not have any orders for this company",
    "title": "Vendor Details"
  },
  "vendorMenu": {
    "tabs": {
      "allBrands": "All Brands",
      "searchByBrand": "Search by Brand",
      "searchByProductLine": "Search by Product Line"
    }
  },
  "viewCompanyProfile": "View Company Profile",
  "volumeDiscountTooltip": "This item has a discount based on order volume."
}
